import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBuildingColumns, faCreditCard, faWallet, faMoneyBillWave, faRightLeft, faHouse, faBolt, faCartShopping,
  faUtensils, faPlane, faPaw, faCar, faShieldHalved, faWifi, faTv, faPercent, faFileInvoice, faShirt, faGamepad,
  faCoins, faShop, faTruck, faBox, faCloud, faBullhorn, faTag, faMobileScreen, faPiggyBank,
} from '@fortawesome/free-solid-svg-icons';

// Colori e nome delle due contabilita'
export const SCOPE_TEMA = {
  azienda: { nome: 'ModenaCinema', colore: '#3b5bdb', scuro: '#364fc7', morbido: '#edf2ff', gradiente: 'linear-gradient(135deg, #4c6ef5 0%, #364fc7 100%)' },
  personale: { nome: 'Personale', colore: '#0ca678', scuro: '#087f5b', morbido: '#e6fcf5', gradiente: 'linear-gradient(135deg, #20c997 0%, #087f5b 100%)' },
};

// Chiavi icona salvate nel database -> icona FontAwesome
export const ICONE = {
  bank: faBuildingColumns, card: faCreditCard, paypal: faMobileScreen, cash: faMoneyBillWave, wallet: faWallet,
  exchange: faRightLeft, piggy: faPiggyBank,
  home: faHouse, bolt: faBolt, cart: faCartShopping, utensils: faUtensils, plane: faPlane, paw: faPaw, car: faCar,
  shield: faShieldHalved, wifi: faWifi, tv: faTv, percent: faPercent, file: faFileInvoice, shirt: faShirt,
  gamepad: faGamepad, coins: faCoins, shop: faShop, truck: faTruck, box: faBox, cloud: faCloud, bullhorn: faBullhorn,
  tag: faTag,
};

export const ICONE_RAPPORTI = ['bank', 'card', 'paypal', 'cash', 'wallet', 'exchange', 'piggy'];
export const ICONE_VOCI = ['home', 'bolt', 'cart', 'utensils', 'plane', 'paw', 'car', 'shield', 'wifi', 'tv', 'percent',
  'file', 'shirt', 'gamepad', 'coins', 'shop', 'truck', 'box', 'cloud', 'bullhorn', 'tag'];

export const TIPI_RAPPORTO = [
  { v: 'conto_corrente', l: 'Conto corrente' }, { v: 'carta', l: 'Carta' }, { v: 'paypal', l: 'PayPal' },
  { v: 'prepagata', l: 'Prepagata' }, { v: 'contanti', l: 'Contanti' }, { v: 'transito', l: 'Conto di transito' },
  { v: 'altro', l: 'Altro' },
];
export const INTESTATARI = ['Azienda', 'Giorgio', 'Francesca', 'Cointestato'];
export const PERSONE = ['Giorgio', 'Francesca', 'Comune'];

export const euro = (n) =>
  n === null || n === undefined ? '—' : new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(n);

export const dataIt = (iso) => (iso ? new Date(iso + 'T00:00:00').toLocaleDateString('it-IT') : '');

// Cerchio colorato con icona
export const IconaTonda = ({ icona, colore, size = 44 }) => (
  <div
    style={{
      width: size, height: size, borderRadius: '50%', background: `${colore || '#868e96'}1f`, color: colore || '#868e96',
      display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, fontSize: size * 0.42,
    }}
  >
    <FontAwesomeIcon icon={ICONE[icona] || faTag} />
  </div>
);
